export function mapProfileToForm(user) {
  const data = user || {};
  const countryCode = data.country_code || '+91';
  const mobileNumber = data.mobile_number || '';

  return {
    fullName: data.full_name || '',
    mobile: mobileNumber ? `${countryCode} ${mobileNumber}`.trim() : '',
    email: data.email || '',
    district: data.district || '',
    college: data.college_name || '',
    dateOfBirth: data.date_of_birth || '',
    gender: data.gender || '',
    countryCode,
    ageGroup: data.age_group || '',
    enableNotification: data.enable_notification ?? true,
    newCourseAlert: data.new_course_alert ?? true,
    progressReminder: data.progress_reminder ?? true,
  };
}

export function buildProfileFormData(form, profileImageFile) {
  const formData = new FormData();

  if (form.fullName) formData.append('full_name', form.fullName.trim());
  if (form.email) formData.append('email', form.email.trim());
  if (form.dateOfBirth) formData.append('date_of_birth', form.dateOfBirth);
  if (form.gender) formData.append('gender', form.gender);
  if (form.ageGroup) formData.append('age_group', form.ageGroup);
  if (form.district) formData.append('district', form.district);
  if (form.countryCode) formData.append('country_code', form.countryCode);
  if (form.college) formData.append('college_name', form.college.trim());

  formData.append('enable_notification', String(form.enableNotification ?? true));
  formData.append('new_course_alert', String(form.newCourseAlert ?? true));
  formData.append('progress_reminder', String(form.progressReminder ?? true));

  if (profileImageFile) {
    formData.append('profile_image', profileImageFile);
  }

  return formData;
}

export function getProfilePhotoUrl(user) {
  const url = user?.profile_image_url?.trim();
  return url || null;
}
